import React, { useEffect, useState } from "react";
import useApi from "../../../../Hooks/useApi";
import MonoBarChart from ".";
import { fetchMonoBarChartData } from "./Utils";
import EmptyChart from "../EmptyChart";
import LoadingSpinner from "../../../Shared/LoadingSpinner";

const MonoContainer = ({ datasetOne, containerClassName = "", exportRef, selectedCity, selectedYear }) => {
  const [monoBarData, setMonoBarData] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  const [error, setError] = useState(null); 

  const { request, loading } = useApi({ isPublic: true });

  useEffect(() => {

    setMonoBarData([]);
    setTotalValue(0);
    setError(null);

    if (!selectedCity?.id || !datasetOne?.name) {
      return;
    }

    const fetchData = async () => {
      try {
        const result = await fetchMonoBarChartData(request, {
          location: selectedCity?.id,
          query: datasetOne?.name,
          year: selectedYear
        });

      
        if (!result) {
          throw new Error("Received empty response from server.");
        }

        if (!Array.isArray(result.data)) {
          console.warn("MonoBar: result.data is not an array", result);
          setMonoBarData([]);
          return;
        }

        setTotalValue(result.total || 0);

        // 5. Safe Data Processing
        const mappedData = result.data
          .filter((item) => {
          
            if (!item) return false;
            
          
            const name = String(item.name || "").trim().toLowerCase();
            return name !== "null" && name !== null && name !== "undefined" && name !== "";
          })
          .map((item) => ({
            ...item,
             name: item.name?.trim() === "" ? "N/A" : item.name,
            value: Number(item.value) || 0, 
          }));

        // Sort: Move "N/A" to the end
        const updatedData = [
          ...mappedData.filter((item) => item.name !== "N/A"),
          ...mappedData.filter((item) => item.name === "N/A"),
        ];

        setMonoBarData(updatedData);

      } catch (err) {
        console.error("MonoBar Error:", err);
        setError("Unable to load chart data.");
      }
    };

    fetchData();
  }, [selectedCity, datasetOne, request, selectedYear]);


  if (loading) {
    return <LoadingSpinner message="Loading Bar Chart..." />;
  }

  if (error) {
    return (
      <div className="flex flex-col justify-center items-center h-[300px] border border-red-200 bg-red-50 rounded">
        <p className="text-red-500 font-semibold">{error}</p>
      </div>
    );
  }


  if (!monoBarData || monoBarData.length === 0 || totalValue === 0) {
    return <EmptyChart />;
  }


  return (
    <MonoBarChart
      data={monoBarData}
      totalValue={totalValue}
      type={datasetOne?.name} 
      containerClassName={containerClassName}
      exportRef={exportRef}
      selectedCity={selectedCity}
      year={selectedYear}
    />
  );
};

export default MonoContainer;